import { createSelector } from '@ngrx/store';

import { AppApprovalFlowState } from '../state/approval-flow.state';

const selectApprovalFlowState = (state: AppApprovalFlowState) => state.approvalFlow;

export const selectApprovalFlowResponse = createSelector(
  selectApprovalFlowState,
  state => state.approvalFlowResponse
);
